import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import PrimaryTheme from '../Themes/Primary'
import { Reducers } from '../Interfaces/Interfaces';

export default function DownloadTransactionForm(props: any) {
    const dispatch = useDispatch()
    const user = useSelector((state: Reducers) => state.user);
    const userType = useSelector((state: Reducers) => state.userType);
    let filter: any = {};

    const [amount, setAmount] = React.useState('');
    const [exportAmount, setExportAmount] = React.useState('');


    const [reference, setReference] = React.useState('');

    const [startDate, setStartDate] = React.useState('');
    const [endDate, setEndDate] = React.useState('');


    const handleDownload = () => {
        if (exportAmount.length !== 0) {
            filter.amount = exportAmount
        }

        if (reference.length !== 0) {
            filter.reference = reference;
        }



        if (endDate.length !== 0) {
            filter.dateCreatedFrom = startDate;
        }
        if (startDate.length !== 0) {
            filter.dateCreatedTo = endDate;
        }
        if (props.routePage === "mytransaction") {
            switch (userType) {
                case '5':
                case '9':
                     {

                    window.open(
                        `https://transactions-${process.env.REACT_APP_STAGE}-alb.bankly.ng/api/Transaction/DownloadAggregatorPersonalTransactions/${user.id}/${JSON.stringify(filter)}`, '_blank',
                    );
                    break;
                }

                case '8': {
                    // do your stuff
                    break;
                }

                default:
                    dispatch({
                        type: "ALERT",
                        payload: {
                            successful: false,
                            message: 'User not allowed'
                        }
                    })
            }


        } else {
            switch (userType) {
                case "5":
                case "9": {
                    window.open(
                        `https://transactions-${process.env.REACT_APP_STAGE}-alb.bankly.ng/api/AggregatorCommission/DownloadReport/${user.id}/?whereCondition=${JSON.stringify(filter)}`, '_blank',
                    );
                    break;
                }

                case '8': {
                    // do your stuff
                    break;
                }

                default:
                    dispatch({
                        type: "ALERT",
                        payload: {
                            successful: false,
                            message: 'User not allowed'
                        }
                    })
            }

        }

    }

    const reset = () => {
        setExportAmount("")
        setReference("")
        setStartDate("")
        setEndDate("")
    }

    return (
        <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
            <div className="col-md-12">
                <span className="badge-pill p-3 d-block col-7 ml-auto mr-auto" style={{
                    background: PrimaryTheme.warn,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}>Download Transactions</span>
            </div>

            {/* <p className="mt-3 mb-5" style={{
          fontFamily: PrimaryTheme.fonts?.RegularFont,
          fontSize: 14,
          color: PrimaryTheme.light
        }}>{subtitle}</p> */}

            <div className="row m-0">





                <div className="col-md-3">

                    <div className="form-group mt-4 text-left">
                        <label htmlFor="amount" style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                        }}>Amount</label>
                        <input
                            type='number'
                            placeholder='Amount'
                            id="amount"
                            value={exportAmount}
                            inputMode="text"
                            onChange={e => setExportAmount(e.target.value)}
                            className="form-control"
                            style={{
                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                color: PrimaryTheme.dark,
                                // background: "#F4F7FC"
                            }} />
                    </div>
                </div>

                <div className="col-md-3">

                    <div className="form-group mt-4 text-left">
                        <label htmlFor="reference" style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                        }}>Transaction Reference</label>
                        <input
                            type='tel'
                            placeholder='Reference'
                            id="reference"
                            value={reference}
                            inputMode="text"
                            onChange={e => setReference(e.target.value)}
                            className="form-control" style={{
                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                color: PrimaryTheme.dark,
                                // background: "#F4F7FC"
                            }} />
                    </div>
                </div>



                <div className="col-md-3">

                    <div className="form-group mt-4 text-left">
                        <label htmlFor="startDate" style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                        }}>Start Date</label>
                        <input
                            type='date'
                            placeholder='Amount'
                            id="startDate"
                            value={startDate}
                            onChange={e => setStartDate(e.target.value)}
                            className="form-control" style={{
                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                color: PrimaryTheme.dark,
                                // background: "#F4F7FC"
                            }} />
                    </div>
                </div>


                <div className="col-md-3">

                    <div className="form-group mt-4 text-left">
                        <label htmlFor="endDate" style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                        }}>End Date</label>
                        <input
                            type='date'
                            placeholder='Amount'
                            id="endDate"
                            value={endDate}
                            onChange={e => setEndDate(e.target.value)}
                            className="form-control" style={{
                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                color: PrimaryTheme.dark,
                                // background: "#F4F7FC"
                            }} />
                    </div>
                </div>

                <div className="col-md-12 text-right">
                    <button className="btn btn-light mr-1" type="reset" onClick={reset}>Reset</button>
                    <button
                        disabled={

                            startDate === "" ||
                            endDate === ""
                        } onClick={handleDownload}
                        className="btn btn-success">{"Download"}</button>
                </div>

            </div>
        </div>
    )
}
